import { Linkedin, ArrowUpRight } from "lucide-react";
import { LEADERSHIP, IMAGES } from "../mock";

export default function Leadership() {
  return (
    <section id="leadership" className="relative py-24 lg:py-28">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#061715]/40 to-transparent" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto reveal">
          <span className="text-xs font-semibold tracking-[0.22em] text-teal-300 uppercase">
            {LEADERSHIP.eyebrow}
          </span>
          <h2 className="font-display font-bold text-white text-3xl lg:text-4xl mt-4 tracking-tight">
            {LEADERSHIP.title}
          </h2>
        </div>

        <div className="mt-14 reveal">
          <div className="grid md:grid-cols-[340px_1fr] gap-10 lg:gap-14 items-center max-w-5xl mx-auto rounded-3xl border border-teal-500/12 bg-gradient-to-br from-white/[0.04] to-transparent p-6 sm:p-8 lg:p-10">
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden border border-teal-500/20">
                <img
                  src={IMAGES.founder}
                  alt={LEADERSHIP.name}
                  className="w-full h-[380px] object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#04100f]/60 to-transparent" />
              </div>
              <div className="absolute -bottom-4 -right-4 h-20 w-20 rounded-2xl bg-gradient-to-br from-teal-400 to-emerald-500 opacity-90 blur-2xl" />
            </div>

            <div>
              <h3 className="font-display font-bold text-white text-2xl lg:text-3xl">
                {LEADERSHIP.name}
              </h3>
              <p className="mt-1 text-teal-300 font-medium">{LEADERSHIP.role}</p>
              <p className="mt-6 text-slate-300/85 leading-relaxed">{LEADERSHIP.bio}</p>
              <a
                href={LEADERSHIP.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="group mt-7 inline-flex items-center gap-2 text-sm font-semibold text-white rounded-lg border border-teal-500/25 bg-teal-500/10 px-4 py-2.5 transition-all hover:bg-teal-500/20 hover:border-teal-400/40"
              >
                <Linkedin size={16} className="text-teal-300" />
                Connect on LinkedIn
                <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}